export default function formatData(data, labels, classname){
    return Object.keys(data).map((key) => ({ label: labels[key], value: data[key], classname: classname}));
}